const CAPTERRA_VKEY = process.env.GATSBY_CAPTERRA_VKEY;
const CAPTERRA_VID = process.env.GATSBY_CAPTERRA_VID;

export default () => {
  const ct = document.createElement('img');
  ct.src = `https://ct.capterra.com/capterra_tracker.gif?vid=${CAPTERRA_VID}&vkey=${CAPTERRA_VKEY}`;
  document.body.appendChild(ct);
};
